<template>
    <div v-html="html"></div>
</template>
<script>
    import zfvServ from '../../service/zfbServ'
    import cache from '../../service/cacheServ'
    import mintUi from '../../lib/mint-ui'
    export default {
        data(){
            return{
                html:''
            }
        },
        methods:{
            fetchVideoPay(){
                let qrCode = this.$route.query.qrcode
                let id =  cache.get('user').openId
                alert('支付页面' + id)
                zfvServ.postZfbPay(id,qrCode).then( res => {
                    if (res.code == '200'){
                        this.html = res.data;
                        this.$nextTick(() => {
                            document.forms[0].submit()   //渲染支付宝支付页面
                        })
                    } else {
                        mintUi.Toast({
                            message: res.message,
                            position: 'bottom'
                        })
                    }

                })
            }
        },
        mounted(){
            this.fetchVideoPay()
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/alipay/alipay.vue